import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppRoot } from './auth/AppRoot';
import { ConfirmProvider } from './components/ConfirmDialog';
import { ErrorBoundary } from './ErrorBoundary';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      {/* One message box for the whole app, so no screen has to hold dialog
          state or remember to render it. */}
      <ConfirmProvider>
        <AppRoot />
      </ConfirmProvider>
    </ErrorBoundary>
  </React.StrictMode>
);